import { FC } from "react";
import { DateFilterChips } from "@/ui";
import { useOrdersData } from "../../context/OrdersDataContext";

const startOfDayUnix = (date: Date) =>
    Math.floor(
        new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
        ).getTime() / 1000,
    );

const endOfDayUnix = (date: Date) =>
    Math.floor(
        new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            23,
            59,
            59,
        ).getTime() / 1000,
    );

export const OrdersDateFilter: FC = () => {
    const { filterState, setFilterState } = useOrdersData();

    const handlePreset = (start?: number | null, end?: number | null) => {
        setFilterState(prev => ({
            ...prev,
            created_at_start: start ?? undefined,
            created_at_end: end ?? undefined,
        }));
    };

    const handleRangeChange = (range: { from: Date; to: Date } | null) => {
        if (!range) return;
        setFilterState(prev => ({
            ...prev,
            created_at_start: startOfDayUnix(range.from),
            created_at_end: endOfDayUnix(range.to),
        }));
    };

    return (
        <DateFilterChips
            end={filterState.created_at_end}
            onPreset={handlePreset}
            onRangeChange={handleRangeChange}
            start={filterState.created_at_start}
        />
    );
};
